import {claimsUrl, policyVehiclesUrl, vehicleInfoUrl} from "./EndpointService.js";
import {API_METHODS, apiFetch, policyApiFetch} from "./ApiService.js";
import {calculateStatus, getPeopleImages, getPolicyPeopleData} from "./DashboardService.js";

export const hasVehicles = async (token_arg) => {
    try {
        return await policyApiFetch(`${policyVehiclesUrl}?per_page=1`, token_arg)
    } catch (error) {
        return null;
    }
};

export const getPolicyVehicles = async (token_arg) => {
    try {
        return await policyApiFetch(`${policyVehiclesUrl}?per_page=1`, token_arg).then(async (data) => {
            return await policyApiFetch(`${policyVehiclesUrl}?per_page=${data.total}`, token_arg)
        });
    } catch (error) {
        return null;
    }
};

export const getVehicleImages = async (token_arg, body) => {
    try {
        return await apiFetch(`${vehicleInfoUrl}`, token_arg, API_METHODS.POST, body);
    } catch (error) {
        return null;
    }
};

export const getVehicleDetail = async (token_arg, vehicleId) => {
    try {
        return await policyApiFetch(`${policyVehiclesUrl}/${vehicleId}`, token_arg);
    } catch (error) {
        return null;
    }
};

export const getVehiclePolicies = async (token_arg, vehicleId) => {
    try {
        return await policyApiFetch(`${policyVehiclesUrl}/${vehicleId}/policies?per_page=1`, token_arg).then(async (data) => {
            return await policyApiFetch(`${policyVehiclesUrl}/${vehicleId}/policies?per_page=${data.total !== 0 ? data.total : 1}`, token_arg)
        });
    } catch (error) {
        return null;
    }
};

export const getVehicleClaims = async (token_arg, vehicleId) => {
    try {
        return await policyApiFetch(`${policyVehiclesUrl}/${vehicleId}/claims`, token_arg)
    } catch (error) {
        return null;
    }
};

export const getPolicyPeopleFunction = (policyToken, token, setIsLoadingPeople, setPeople, setErrorPage) => {
    setIsLoadingPeople(true)
    getPolicyVehicles(policyToken).then((data) => {
        let vehicles = data.data;
        const vehicleIds = vehicles.map((item) => ({vehicleId: item.id}));
        getVehicleImages(token, vehicleIds).then((vehicleImage) => {
            getPolicyPeopleValues(policyToken, token, vehicleIds, setPeople, data, vehicles, vehicleImage, setIsLoadingPeople, setErrorPage)
        }).catch(() => {
            setErrorPage(true);
        });
    }).catch(() => {
        setErrorPage(true)
    })
}

function getPolicyPeopleValues(policyToken, token, ids, setPeople, data, vehicles, vehicleImage, setIsLoadingPeople, setErrorPage) {
    getPolicyPeopleData(policyToken).then(async (res) => {
        const data = res.data;
        const ids = data.map((item) => ({id: item.id, personId: item.person_id}));
        getPeopleImagesData(token, ids, setPeople, data, vehicles, vehicleImage, setIsLoadingPeople, setErrorPage)
    }).catch(() => {
        setErrorPage(true)
    });
}

function getPeopleImagesData(token, ids, setPeople, data, vehicles, vehicleImage, setIsLoadingPeople, setErrorPage) {
    getPeopleImages(token, ids).then((imageData) => {
        setPeople([])
        data.map((item) => {
            const imageInfo = imageData.find(image => image.id === item.id);
            if (imageInfo) {
                item.image = imageInfo.image === '' ? null : imageInfo.image;
                item.status = imageInfo.status;
            }
            if (item.status !== -1) {
                calculateAndSetPeople(vehicles, vehicleImage, setPeople, item);
            }
        })
        setIsLoadingPeople(false)
    }).catch(() => {
        setErrorPage(true)
    })
}

function calculateAndSetPeople(vehicles, vehicleImage, setPeople, item) {
    let tempVehicles = vehicles.filter(vehicle => vehicle.policyholder.id === item.id);
    if(tempVehicles.length > 0) {
        tempVehicles.map((vehicle) => {
            const imageVehicle = vehicleImage.find(image => image.id === vehicle.id);
            if (imageVehicle) {
                vehicle.image = imageVehicle.image === '' ? null : imageVehicle.image;
                vehicle.status = imageVehicle.status;
            }
        });
        item.vehicles = tempVehicles;
        setPeople(current => [...current, item])
    }
}

export function getVehiclePoliciesData(vehicle, policyToken, vehicleId, setNotActivePolicies, setActivePolicies, setVehicle, setVehiclePolicies, setIsLoadingSX, setIsLoadingDX, setErrorPage) {
    getVehiclePolicies(policyToken, vehicleId).then((data) => {
        let policies = data.data;
        policies.map((item) => {
            item = calculateStatus(item);
            if (item.status !== -1) {
                if(item.status === 1) setNotActivePolicies(true);
                else setActivePolicies(true);
                setVehicle(vehicle);
                setVehiclePolicies(current => [...current, item])
            }
        });
        setIsLoadingSX(false)
        setIsLoadingDX(false)
    }).catch(() => {
        setErrorPage(true)
    })
}
